import { render } from "./LibExpert.vue?vue&type=template&id=10df00d3&scoped=true"
import script from "./LibExpert.vue?vue&type=script&lang=js"
export * from "./LibExpert.vue?vue&type=script&lang=js"

import "./LibExpert.vue?vue&type=style&index=0&id=10df00d3&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10df00d3"]])

export default __exports__